export default __webpack_public_path__ + "static/media/logo-main.ed2b25e9.png";